import axios from 'axios'
import { ElMessage } from 'element-plus'
import { netConfig } from '@/config/net.config'
import { APP_ID, LANG_KEY, LONGITUDE_KEY, LATITUDE_KEY } from '@/config/app.config'
import { getToken, getSessionId } from '@/utils/token'
import { safeLocalStorage, isBrowser } from '@/utils/ssr'

const instance = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_URL,
  timeout: netConfig.timeout,
  headers: { 'Content-Type': 'application/json' },
})

// 请求拦截：自动注入 6 个公共字段
instance.interceptors.request.use((config) => {
  if (config.method?.toLowerCase() === 'post') {
    const commonFields = {
      language: safeLocalStorage.getItem(LANG_KEY) || 'zh-Hans',
      token: getToken(),
      sessionId: getSessionId(),
      longitude: Number(safeLocalStorage.getItem(LONGITUDE_KEY) || 0),
      latitude: Number(safeLocalStorage.getItem(LATITUDE_KEY) || 0),
      appId: APP_ID,
    }
    if (config.data instanceof FormData) {
      // multipart/form-data 请求，逐个追加公共字段
      Object.entries(commonFields).forEach(([k, v]) => {
        config.data.append(k, String(v))
      })
      // 删除默认 Content-Type，让浏览器自动设置 multipart/form-data + boundary
      delete config.headers['Content-Type']
    } else if (config.data instanceof URLSearchParams) {
      // form-urlencoded 请求，逐个追加公共字段
      Object.entries(commonFields).forEach(([k, v]) => {
        config.data.append(k, String(v))
      })
    } else {
      config.data = { ...config.data, ...commonFields }
    }
  }
  return config
})

// 响应拦截：统一错误处理
instance.interceptors.response.use(
  (response) => {
    const data = response.data
    if (data.code === netConfig.successCode) {
      return data
    }
    // 支付等第三方接口无 code 字段，直接透传
    if (data.code === undefined || data.code === null) {
      return { data }
    }
    if (data.code === 600 || data.code === 601) {
      // 未登录，跳转到登录页（避免循环依赖，用 window.location）
      if (isBrowser) {
        const redirect = encodeURIComponent(window.location.pathname + window.location.search)
        if (!window.location.pathname.includes('/login')) {
          window.location.href = `/login?redirect=${redirect}`
        }
      }
      return Promise.reject(data)
    }
    ElMessage.error(data.msg || '请求失败')
    return Promise.reject(data)
  },
  (error) => {
    const msg = error.response?.data?.msg || error.message || '网络错误'
    ElMessage.error(msg)
    return Promise.reject(error)
  },
)

export default instance
